// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"3ed43890","127":"334bf46f","181":"163ba275","556":"7ff7f94b","609":"cf31d894","781":"e5b5dfd9","884":"e5e9280a"}[chunkId] + ".chunk.js";
};